export var UniversNetworkLinkCreate;
(function (UniversNetworkLinkCreate) {
    let type;
    (function (type) {
        type["OWN"] = "own";
        type["COMPETITOR"] = "competitor";
        type["ATTRACTOR"] = "attractor";
        type["INFO"] = "info";
    })(type = UniversNetworkLinkCreate.type || (UniversNetworkLinkCreate.type = {}));
})(UniversNetworkLinkCreate || (UniversNetworkLinkCreate = {}));
